(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const initMainInfoSizing = () => {
    const productOuter = document.querySelector('.product__outer');
    const productInner = document.querySelector('.product__outer-inner');
    const mainInfo = document.querySelector('.product__info-inner');

    if (!productOuter || !mainInfo || !productInner) return;

    const mainInfoHeight = mainInfo.offsetHeight;
    const productInnerHeight = productInner.offsetHeight;
    productOuter.style.minHeight = `${Math.max(mainInfoHeight, productInnerHeight)}px`;

    const resizenterval = setInterval(() => {
      const mainInfoHeight = mainInfo.offsetHeight;
      const productInnerHeight = productInner.offsetHeight;
      productOuter.style.minHeight = `${Math.max(mainInfoHeight, productInnerHeight)}px`;
    }, 500);

    setTimeout(() => {
      clearInterval(resizenterval);
    }, 5000);

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        const mainInfoHeight = mainInfo.offsetHeight;
        const productInnerHeight = productInner.offsetHeight;
        productOuter.style.minHeight = `${Math.max(mainInfoHeight, productInnerHeight)}px`;
      });

      resizeObserver.observe(mainInfo);
    }
  };

  const initProductTabs = () => {
    const tabsContainer = document.querySelector('.product__tabs');
    const tabs = document.querySelectorAll('.product__tabs-item[role="tab"]');
    const panels = document.querySelectorAll('.product__tabs-content-item[role="tabpanel"]');

    if (!tabsContainer || tabs.length === 0) return;

    let activeTab = document.querySelector('.product__tabs-item[aria-selected="true"]');
    if (!activeTab && tabs.length > 0) {
      activeTab = tabs[0];
      setActiveTab(activeTab, tabs, panels);
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        setActiveTab(tab, tabs, panels);
      });
    });

    function setActiveTab(activeTab, allTabs, allPanels) {
      const activeTabId = activeTab.getAttribute('data-tab-id');

      // Update all tabs
      allTabs.forEach(tab => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', isActive);
        tab.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive) {
          tab.classList.add('product__tabs-item--active');
        } else {
          tab.classList.remove('product__tabs-item--active');
        }
      });

      // Update all panels
      allPanels.forEach(panel => {
        const panelId = panel.getAttribute('data-tab-id');
        const isActive = panelId === activeTabId;

        if (isActive) {
          panel.removeAttribute('hidden');
          panel.classList.add('product__tabs-content-item--active');
        } else {
          panel.setAttribute('hidden', '');
          panel.classList.remove('product__tabs-content-item--active');
        }
      });
    }

    const reviewsBlock = document.querySelector('[data-block-handle="reviews"]');
    if (reviewsBlock) {
      reviewsBlock.style.cursor = 'pointer';
      reviewsBlock.addEventListener('click', (e) => {
        e.preventDefault();

        const reviewsTab = document.querySelector('[data-tab-id="reviews"]');
        if (reviewsTab) {
          setActiveTab(reviewsTab, tabs, panels);

          const tabsSection = document.querySelector('.product__tabs');
          if (tabsSection) {
            tabsSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    }
  };

  const initCountColors = () => {
    const colorsEl = document.querySelector('variant-colors');
    if (!colorsEl) return;

    const colorsGroup = colorsEl.querySelector('[data-colors-group]');
    const colors = colorsEl.querySelectorAll('[data-colors-item]');
    const colorsLabel = colorsEl.querySelector('[data-colors-label]');
    const colorsCountEl = colorsEl.querySelector('[data-colors-count]');
    const colorsText = colorsEl.querySelector('[data-colors-text]');

    if (!colorsGroup || !colorsLabel || !colorsCountEl || !colorsText) return;

    const colorsInner = colorsGroup.querySelector('.product-form__colors-inner');
    if (!colorsInner) return;

    const countProcedure = () => {
      let visibleColors = 0;
      let firstColorTop = undefined;
      colors.forEach((color, index) => {
        const colorPosition = color.getBoundingClientRect();
        if (index === 0) {
          firstColorTop = colorPosition.top;
        }

        if (colorPosition.top === firstColorTop) {
          visibleColors++;
        } else {
          return;
        }
      });

      const additionalColors = colors.length - visibleColors;

      if (additionalColors > 0) {
        colorsCountEl.textContent = '+' + additionalColors;

        const pluralizeCount = (count) => {
          if (count === 1) return 'single';
          if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return 'plural';
          return 'multiple';
        };

        const pluralForm = pluralizeCount(additionalColors);

        if (pluralForm === 'single') {
          colorsText.textContent = colorsText.dataset.colorsTextSingle;
        } else if (pluralForm === 'plural') {
          colorsText.textContent = colorsText.dataset.colorsTextPlural;
        } else {
          colorsText.textContent = colorsText.dataset.colorsTextMultiple;
        }

        colorsLabel.classList.add('product-form__colors-label--visible');
      } else {
        colorsCountEl.textContent = '';
        colorsText.textContent = '';
        colorsLabel.classList.remove('product-form__colors-label--visible');
      }
    }

    // check after 250ms, then check again after 100ms, due to the checking colors width vs label width
    setTimeout(() => {
      countProcedure();

      setTimeout(() => {
        countProcedure();
      }, 100);
    }, 250);
  };

  // Global handler for all notify buttons
  let notifyModalObserver = null;

  const waitForModalAndLocalize = () => {
    const modal = document.querySelector('.wcBsiModal');
    if (modal) {
      localizeNotifyModal();
      return;
    }

    if (notifyModalObserver) {
      notifyModalObserver.disconnect();
    }

    notifyModalObserver = new MutationObserver((mutations, obs) => {
      const modal = document.querySelector('.wcBsiModal');
      if (modal) {
        localizeNotifyModal();
        obs.disconnect();
        notifyModalObserver = null;
      }
    });

    notifyModalObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  const localizeNotifyModal = () => {
    if (!window.notifyStrings) return;

    const titleEl = document.querySelector('.wcBsiHeaderTitle');
    const labelEl = document.querySelector('.wcBsiFormLabel');
    const emailInput = document.querySelector('#wcBsiEmail');
    const submitBtn = document.querySelector('.wcBsiFormBtnSubmit');

    if (titleEl && window.notifyStrings?.title) titleEl.innerHTML = window.notifyStrings.title;
    if (labelEl && window.notifyStrings?.description) labelEl.innerHTML = window.notifyStrings.description;
    if (emailInput && window.notifyStrings?.emailPlaceholder) {
      const temp = document.createElement('div');
      temp.innerHTML = window.notifyStrings.emailPlaceholder;
      emailInput.placeholder = temp.textContent || temp.innerText || '';
    }
    if (submitBtn && window.notifyStrings?.submit) submitBtn.innerHTML = window.notifyStrings.submit;
  };

  const handleNotifyButtonClick = (evt) => {
    const notifyButton = evt.target.closest('[data-product-notify]');
    if (!notifyButton) return;

    evt.preventDefault();
    const appBtn = notifyButton.nextElementSibling;

    if (appBtn && appBtn.classList.contains('wc_wl_bis_btn')) {
      const variantId = notifyButton.dataset.variantId;
      if (variantId) {
        appBtn.setAttribute('data-variant_id', variantId);
      }
      const appBtnInner = appBtn.querySelector('button');
      if (appBtnInner) {
        appBtnInner.click();
        waitForModalAndLocalize();
      }
    }
  };

  // Set up global event delegation for all notify buttons
  document.addEventListener('click', handleNotifyButtonClick);

  const initColorsPopup = () => {
    const colorsPopup = document.querySelector('.product-popup-modal__colors-hld');
    if (!colorsPopup) return;

    const colorsList = colorsPopup.querySelectorAll('[data-color-item]');
    const clearBtns = colorsPopup.querySelectorAll('[data-clear-chosen-colors]');
    const addToCartBtn = colorsPopup.querySelector('[data-chosen-colors-add-to-cart]');

    if (!colorsList || !clearBtns || !addToCartBtn) return;

    let addToCartData = {
      'items': []
    };

    colorsList.forEach(color => {
      const colorCheckbox = color.querySelector('[data-color-checkbox]');
      if (colorCheckbox) {
        colorCheckbox.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (color.classList.contains('is-active')) {
            color.classList.remove('is-active');
            const quantityInput = color.querySelector('input[name="quantity"]');
            if (quantityInput) {
              quantityInput.value = 0;
              quantityInput.previousElementSibling.classList.add('disabled');
              const event = new CustomEvent('quantity-in-popup-changed', {
                bubbles: true
              });
              window.dispatchEvent(event);
            }
          } else {
            color.classList.add('is-active');
            const quantityInput = color.querySelector('input[name="quantity"]');
            if (quantityInput) {
              quantityInput.value = 1;
              quantityInput.previousElementSibling.classList.remove('disabled');
            };
            const event = new CustomEvent('quantity-in-popup-changed', {
              bubbles: true
            });
            window.dispatchEvent(event);
          }
        });
      }
    });

    const search = colorsPopup.querySelector('[name="color_search"]');
    if (search) {
      search.addEventListener('input', (e) => {
        const searchValue = e.target.value.toLowerCase();
        let resultsEmpty = true;
        let visibleIndex = 0;
        console.log(searchValue);
        colorsList.forEach(color => {
          const colorName = color.dataset.colorName.toLowerCase();
          const colorSymbol = color.dataset.colorSymbol.toLowerCase();
          const colorEan = color.dataset.colorEan.toLowerCase();
          color.classList.remove('is-first');

          if (colorName.includes(searchValue) || (searchValue.length > 2 && colorSymbol.includes(searchValue)) || (searchValue.length > 2 && colorEan.includes(searchValue))) {
            color.style.display = 'flex';
            resultsEmpty = false;
            visibleIndex++;
            if (visibleIndex === 1) {
              color.classList.add('is-first');
            }
          } else {
            color.style.display = 'none';
          }
        });

        const colorsListHld = colorsPopup.querySelector('[data-colors-list]');
        if (!colorsListHld) return;

        if (resultsEmpty) {
          const noResultsSpan = document.createElement('span');
          noResultsSpan.classList.add('product-popup-modal__colors-list-empty');
          if (colorsListHld) {
            const noResultsText = document.createTextNode(colorsListHld.dataset.noResultsText);
            noResultsSpan.appendChild(noResultsText);
            if (!colorsListHld.querySelector('.product-popup-modal__colors-list-empty')) {
              colorsListHld.appendChild(noResultsSpan);
            }
          }
        } else {
          const noResultsSpan = colorsListHld.querySelector('.product-popup-modal__colors-list-empty');
          if (noResultsSpan) {
            noResultsSpan.remove();
          }
        }
      });
    }

    const handleChosenColors = () => {
      const chosenColorsList = colorsPopup.querySelector('[data-chosen-list]');
      if (!chosenColorsList) return;

      let chosenColorsSum = 0;

      // create object with colors and quantities, use {name: 'Name', quantity: quantity}
      const chosenColors = {};
      addToCartData = {
        'items': []
      };
      let chosenColorsIndex = 0;

      colorsList.forEach(color => {
        const quantityInput = color.querySelector('input[name="quantity"]');
        if (quantityInput && quantityInput.value > 0) {
          chosenColorsSum += parseInt(quantityInput.value);
          chosenColors[chosenColorsIndex] = {
            name: color.dataset.colorName,
            variantID: color.dataset.variantId,
            quantity: parseInt(quantityInput.value),
            colorSwatch: color.querySelector('.product-popup-modal__color-item-swatch')?.outerHTML
          };
          const itemData = {
            'id': color.dataset.variantId,
            'quantity': parseInt(quantityInput.value)
          }
          addToCartData.items.push(itemData);
          chosenColorsIndex++;
        }
      });

      chosenColorsList.innerHTML = '';
      Object.values(chosenColors).forEach(color => {
        const colorItem = document.createElement('div');
        colorItem.classList.add('product-popup-modal__color-item-chosen');
        colorItem.innerHTML = color.colorSwatch;
        colorItem.innerHTML += `<span class="product-popup-modal__color-item-chosen-name">${color.name}</span>`;
        colorItem.innerHTML += `<span class="product-popup-modal__color-item-chosen-quantity">${color.quantity} ${chosenColorsList.dataset.piecesText}</span>`;
        chosenColorsList.appendChild(colorItem);
      });

      if (Object.values(chosenColors).length === 0) {
        chosenColorsList.innerHTML = `<span class="product-popup-modal__colors-chosen-list-empty">${chosenColorsList.dataset.emptyText}</span>`;
        addToCartBtn.disabled = true;
      } else {
        addToCartBtn.disabled = false;
      }

      const chosenColorsCountEl = colorsPopup.querySelector('[data-chosen-count]');
      if (chosenColorsCountEl) {
        chosenColorsCountEl.textContent = chosenColorsSum;
      }

      if (chosenColorsSum > 0) {
        clearBtns.forEach(btn => {
          btn.classList.add('is-active');
        });
      } else {
        clearBtns.forEach(btn => {
          btn.classList.remove('is-active');
        });
      }
    }

    const colorsChosenExpand = colorsPopup.querySelector('[data-colors-chosen-expand]');
    const closeChosenExpand = colorsPopup.querySelector('[data-close-chosen-expand]');
    if (colorsChosenExpand && closeChosenExpand) {
      colorsChosenExpand.addEventListener('click', () => {
        const chosenHld = colorsPopup.querySelector('[data-chosen-hld]');
        if (chosenHld) {
          chosenHld.classList.toggle('is-expanded');
        }
      });
      closeChosenExpand.addEventListener('click', () => {
        const chosenHld = colorsPopup.querySelector('[data-chosen-hld]');
        if (chosenHld) {
          chosenHld.classList.remove('is-expanded');
        }
      });
    }

    const clearChosenColors = () => {
      colorsList.forEach(color => {
        if (color.classList.contains('is-active')) {
          color.classList.remove('is-active');
        }
        const quantityInput = color.querySelector('input[name="quantity"]');
        if (quantityInput) {
          quantityInput.value = 0;
          quantityInput.previousElementSibling.classList.add('disabled');
        }
      });
      const chosenColorsList = colorsPopup.querySelector('[data-chosen-list]');
      if (chosenColorsList) {
        chosenColorsList.innerHTML = `<span class="product-popup-modal__colors-chosen-list-empty">${chosenColorsList.dataset.emptyText}</span>`;
      }
      const chosenColorsCountEl = colorsPopup.querySelector('[data-chosen-count]');
      if (chosenColorsCountEl) {
        chosenColorsCountEl.textContent = '0';
      }
      clearBtns.forEach(btn => {
        btn.classList.remove('is-active');
      });
      const chosenHld = colorsPopup.querySelector('[data-chosen-hld]');
      if (chosenHld) {
        chosenHld.classList.remove('is-expanded');
      }
      addToCartData = {
        'items': []
      };
      addToCartBtn.disabled = true;
    }

    clearBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (confirm(colorsPopup.dataset.clearConfirmText)) {
          clearChosenColors();
        }
      });
    });

    window.addEventListener('quantity-in-popup-changed', (e) => {
      e.stopPropagation();
      colorsList.forEach(color => {
        const quantityInput = color.querySelector('input[name="quantity"]');
        if (quantityInput && quantityInput.value === '0') {
          color.classList.remove('is-active');
        }
      });
      handleChosenColors();
    });

    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();

      addToCartBtn.classList.add('loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addToCartData)
      })
        .then(response => {
          clearChosenColors();
          const popupClose = colorsPopup.querySelector('.product-popup-modal__close');
          if (popupClose) {
            popupClose.click();
          }
          addToCartBtn.classList.remove('loading');
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((error) => {
          console.error('Error:', error);
          addToCartBtn.classList.remove('loading');
        });
    });
  }

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initMainInfoSizing();
    initProductTabs();
    initCountColors();
    initColorsPopup();
  });

  window.addEventListener('resize', function () {
    initCountColors();
  });



  initProductAccordion();
  initZoomImage();
  initMainInfoSizing();
  initProductTabs();
  initCountColors();
  initColorsPopup();
})();
